export default {
    CREATE_PROJECT: "Создать проект",
    SET_READONLY_MODE_HINT: "Открыть режим просмотра",
    SET_EDIT_MODE_HINT: "Открыть режим редактирования"
};
